// TODO:UNCOMMENT  WHEN WWG IS READY TO ACCEPT CREDIT CARD REGISTRATION

// import { useEffect, useState } from "react";
// import { useSubscriptionService } from "../../../services/subscriptions";
// import {
//     RetrieveCardData,
//     StripePaymentStatusCollectData,
//     StripeSetupIntent,
// } from "../../common/stripe/stripe-setup-intent";
// import { Spinner } from "../../common/spinner";
// import { LAB_PRICE } from "../../../lib/common/constants";

export type TCardInfo = {
    brand: string;
    last4: string;
    exp_month: number;
    exp_year: number;
};

// export const StripeComponent = () => {
//     const [showForm, setShowForm] = useState<boolean>(false);
//     const [clientSecret, setClientSecret] = useState<string>("");
//     const [hasSavedCard, setHasSavedCard] = useState<boolean>(false);
//     const [cardInfo, setCardInfo] = useState<TCardInfo>();

//     const { getSetupIntent, deleteCardInfo } = useSubscriptionService();
//     const urlClientSecret = new URLSearchParams(window.location.search).get(
//         "setup_intent_client_secret"
//     );

//     const flowInstance: "inputCardData" | "collectData" =
//         urlClientSecret === null ? "inputCardData" : "collectData";

//     const ChangePaymentInfoHandler = () => {
//         deleteCardInfo();
//         setHasSavedCard(false);
//         setShowForm(true);
//     };

//     useEffect(() => {
//         if (flowInstance === "inputCardData") {
//             getSetupIntent().then((data) => {
//                 if (data.setupIntent) {
//                     setClientSecret(data.setupIntent?.client_secret);
//                     setShowForm(true);
//                 }
//                 if (data.customer?.paymentMethod) {
//                     setHasSavedCard(true);
//                     setShowForm(false);
//                 }
//                 if (data.cardInfo) {
//                     setCardInfo(data.cardInfo);
//                 }
//             });
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [flowInstance]);
//     return (
//         <>
//             <div className="row lab-row bg-light rounded p-4">
//                 {flowInstance === "collectData" && (
//                     <>
//                         <StripePaymentStatusCollectData
//                             clientSecret={urlClientSecret as string}
//                         />
//                     </>
//                 )}
//                 {flowInstance === "inputCardData" && (
//                     <>
//                         <div className="col-lg-6 ">
//                             <h3 className="fw-bold mb-3">
//                                 Start Your Free Month <br /> No Charges Today
//                             </h3>
//                             <p className="text-muted lh-lg">
//                                 <strong>
//                                     You won’t be charged now. Your first month
//                                     is completely free.
//                                 </strong>{" "}
//                                 <br />
//                                 After that, your subscription will continue at $
//                                 {LAB_PRICE}/month, billed monthly.
//                                 {/* You can cancel anytime before your trial
//                                         ends to avoid being charged. */}
//                             </p>
//                         </div>
//                         <div className="col-lg-6">
//                             {showForm && !hasSavedCard && (
//                                 <>
//                                     <h5 className="fw-bold mb-4">
//                                         Complete your payment details.
//                                     </h5>
//                                     <div className="card">
//                                         <div className="card-body">
//                                             {!showForm && (
//                                                 <>
//                                                     <p className="text-center mb-4">
//                                                         <Spinner />
//                                                     </p>
//                                                     <p className="mb-4">
//                                                         &nbsp;
//                                                     </p>
//                                                 </>
//                                             )}
//                                             <div className="mt-2">
//                                                 <StripeSetupIntent
//                                                     clientSecret={clientSecret}
//                                                 />
//                                             </div>

//                                             <div className="text-center mt-3 text-bold">
//                                                 <p>
//                                                     <i className="fa-solid fa-lock me-2"></i>
//                                                     Your payment details are
//                                                     encrypted and 100% secure.
//                                                     <small className="d-block text-muted mt-2 text-center">
//                                                         Secure payment powered
//                                                         by Stripe. <br />
//                                                         {/* You’ll receive a reminder before your trial ends. */}
//                                                     </small>
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </>
//                             )}
//                             {!!!showForm && !!hasSavedCard && (
//                                 <>
//                                     <h5 className="fw-bold mb-4">
//                                         Your Payment Info{" "}
//                                     </h5>
//                                     <div className="row gap-3">
//                                         <RetrieveCardData cardData={cardInfo} />
//                                         <div className="col my-auto">
//                                             <button
//                                                 className="btn btn-outline-primary w-100"
//                                                 type="button"
//                                                 onClick={
//                                                     ChangePaymentInfoHandler
//                                                 }
//                                             >
//                                                 Change Payment Info
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </>
//                             )}
//                         </div>
//                     </>
//                 )}
//             </div>
//         </>
//     );
// };

export const StripeComponent = () => {
    return (
        <div className="lab-row row justify-content-center">
            <div className="col-md-6  bg-light rounded p-4 text-center border shadow-sm">
                <h2 className="text-primary mb-3">Payments Coming Soon!</h2>
                <p className="">
                    🎉 Lucky you! <br /> Our platform is still{" "}
                    <strong>100% free</strong> while we finalize our payment
                    system.
                </p>

                <p className="text-muted">
                    You can continue using all features without interruption for
                    now. Just don’t forget to check back soon to complete your
                    payment registration — so your service isn't affected once
                    we go live!
                </p>
            </div>
        </div>
    );
};
